import { Link } from "@mui/material";
import React from "react";

interface AcxQuestionRubricProps {
    urlString: string;
}

const AcxQuestionRubric = (props: AcxQuestionRubricProps) => {
    return (
        <Link href={props.urlString} target="_blank">
            Rubric
        </Link>
    );
};

export default AcxQuestionRubric;
